module.exports = __webpack_public_path__ + "img/default-img.c2c82089.png";